export enum AuditTrailActions {
  ShipmentName = 'SHIPMENT_NAME',
  ShipmentCreate = 'SHIPMENT_CREATE',
  ShipmentDetails = 'SHIPMENT_DETAILS',
  TruckDetails = 'TRUCK_DETAILS',
  TruckCreate = 'TRUCK_CREATE',
  DriverDetails = 'DRIVER_DETAILS',
  DriverCreate = 'DRIVER_CREATE'
}
